import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 px-4 bg-white border-b-8 border-brand-light" data-id="element-85">
      <div className="max-w-4xl mx-auto" data-id="element-86">
        <div className="bg-brand-light border-4 border-brand-gold p-8 sm:p-12 rounded-2xl text-center shadow-2xl relative overflow-hidden" data-id="element-87">
          <p className="text-sm sm:text-base font-black text-brand-dark uppercase tracking-widest mb-6" data-id="element-88">
            IL TUO INVESTIMENTO È PROTETTO AL 100%
          </p>

          <div className="w-20 h-20 mx-auto bg-brand-gold/20 rounded-full flex items-center justify-center mb-6 border-2 border-brand-gold/50" data-id="element-89">
            <ShieldCheck className="w-10 h-10 text-brand-dark" data-id="element-90" />
          </div>

          <h3 className="text-3xl sm:text-4xl font-black text-brand-dark mb-4 tracking-tight uppercase" data-id="element-91">
            🛡️ Garanzia Totale di 7 Giorni
          </h3>

          <p className="text-base sm:text-lg font-black text-brand-red mb-6 uppercase tracking-wide" data-id="element-92">
            Il tuo denaro è protetto al 100%
          </p>

          <div className="text-base sm:text-lg text-brand-dark/90 font-medium max-w-3xl mx-auto leading-relaxed" data-id="element-93">
            <p data-id="element-94">
              Hai 7 giorni completi per esplorare l'intero sistema, rivedere i
              programmi, implementare le sequenze e valutare i risultati con i
              tuoi allievi. Se per qualsiasi motivo non sei completamente
              soddisfatto, ti rimborsiamo il 100% del denaro. Zero rischio.
              Nessuna domanda richiesta.
            </p>
          </div>
        </div>
      </div>
    </section>;
}